import { render, staticRenderFns } from "./GainOnSale.vue?vue&type=template&id=493777f5&scoped=true&"
import script from "./GainOnSale.vue?vue&type=script&lang=js&"
export * from "./GainOnSale.vue?vue&type=script&lang=js&"
import style0 from "./GainOnSale.vue?vue&type=style&index=0&id=493777f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493777f5",
  null
  
)

export default component.exports